const t = document.querySelector('.t');

const tLength = t.getTotalLength();
// console.log(tLength);
